// The single source of truth for global keyboard shortcuts
// (command-palette-and-search.md §Keyboard). Both useGlobalKeys (the handler)
// and the CheatSheet overlay (the docs) read this one table, so adding a
// shortcut is a one-line change that stays in sync across both — no drift
// between what fires and what's documented.

export type GlobalKeyHandlers = {
  readonly goHome: () => void;
  readonly goSettings: () => void;
  readonly newAgent: () => void;
  readonly toggleCheat: () => void;
  readonly togglePalette: () => void;
};

export type KeyBinding = {
  // The handler this binding fires.
  readonly action: keyof GlobalKeyHandlers;
  // Second key of a `G`-prefixed chord (lowercase), e.g. "h" for "G then H".
  // Mutually exclusive with `key`.
  readonly chord?: string;
  // Human-readable keys for the cheat sheet, e.g. "⌘ K", "G then H".
  readonly display: string;
  readonly id: string;
  // Trigger key (matched against KeyboardEvent.key case-insensitively) for a
  // single-key binding. Omitted for chords.
  readonly key?: string;
  readonly label: string;
  // Requires the ⌘/Ctrl modifier; a `meta` binding fires even while typing.
  readonly meta?: boolean;
};

export const GLOBAL_KEYS: ReadonlyArray<KeyBinding> = [
  {
    action: "togglePalette",
    display: "⌘ K",
    id: "palette",
    key: "k",
    label: "Command palette",
    meta: true,
  },
  {
    action: "toggleCheat",
    display: "?",
    id: "cheat",
    key: "?",
    label: "This cheat sheet",
  },
  { action: "newAgent", display: "N", id: "new", key: "n", label: "New agent" },
  {
    action: "goHome",
    chord: "h",
    display: "G then H",
    id: "home",
    label: "Go to repositories",
  },
  {
    action: "goSettings",
    chord: "s",
    display: "G then S",
    id: "settings",
    label: "Go to settings",
  },
];
